import { 
    call,
    takeEvery 
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import PersonFactory from "../../Entity/Factories/PersonFactory";

export default function* personForPersonDetailsPage(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, `contacts/${action.payload?.contactId}`);

    const person = PersonFactory.create(res.data.data);

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, person);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchPersonForPersonDetailsPage() {
  yield takeEvery(Constants.GLOBAL_PERSON_FOR_PERSON_DETAILS_PAGE, personForPersonDetailsPage);
}
